import {useLocation} from 'react-router';
import {tr} from '../i18n/idioma';
import {Pestanas} from './pestanas-inventario';

// Analisis (menu nuevo, 6/10/2026): Reportes son las tablas dinamicas en
// pantalla; Informes, los libros de Excel que se descargan.
export function PestanasAnalisis() {
  const {search, pathname} = useLocation();
  const pestanas = [
    {a: '/analisis/reportes', texto: tr('Reportes', 'Pivot reports')},
    {a: '/analisis/informes', texto: tr('Informes', 'Excel reports')},
  ];
  return (
    <Pestanas
      pestanas={pestanas}
      busquedaPara={a => (a === pathname ? search : '')}
      nombre={tr('Secciones de análisis', 'Analysis sections')}
    />
  );
}
